import { render, staticRenderFns } from "./OfferFormGroupPartner.vue?vue&type=template&id=8f53b716&"
import script from "./OfferFormGroupPartner.vue?vue&type=script&lang=js&"
export * from "./OfferFormGroupPartner.vue?vue&type=script&lang=js&"
import style0 from "./OfferFormGroupPartner.vue?vue&type=style&index=0&id=8f53b716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports